const getTimestamp = (str) => {
	if (str) {
		return Number(str.replace('/Date(', '').replace('+0800)/', ''));
	}
	return '';
};

export default getTimestamp;
